import React from "react";
import { Link } from "react-router-dom";
import LandingLayout from "./LandingLayout";

const CreatorsNetworkPage = () => {
  return (
    <LandingLayout title="Creators Network | Rebel">
      <section className="creator-hero">
        <div className="creator-hero__glow creator-hero__glow--one"></div>
        <div className="creator-hero__glow creator-hero__glow--two"></div>

        <div className="creator-hero__copy">
          <p className="eyebrow">Rebel Creator Network</p>

          <h1>
            Built for<br /> creators <span>who move<br /> culture.</span>
          </h1>

          <p className="creator-hero__text">
            Create original content, build a loyal audience, and earn from the work you already love producing. Rebel gives Bahamian creators a home to grow.
          </p>

          <div className="creator-hero__actions">
            <a className="network-button network-button--primary" href="#join">
              Become a Creator
            </a>
            <a className="network-button network-button--secondary" href="#creator-paths">
              Explore Creator Paths
            </a>
          </div>

          <div className="creator-proof">
            <div className="creator-proof__avatars">
              <img src="/assets/creators/creator-1.png" alt="Rebel creator" />
              <img src="/assets/creators/creator-2.png" alt="Rebel creator" />
              <img src="/assets/creators/creator-3.png" alt="Rebel creator" />
              <img src="/assets/creators/creator-4.png" alt="Rebel creator" />
            </div>

            <p>
              <strong>Your content. Your audience.</strong>
              <span>One Bahamian creator community.</span>
            </p>
          </div>
        </div>

        <div className="creator-hero__visual">
          <div className="hero-feature hero-feature--main">
            <img src="/assets/Bravo.jpg" alt="Documentary creator content" />
            <div className="hero-feature__overlay">
              <span>Original Stories</span>
              <strong>Share the stories only you can tell.</strong>
            </div>
          </div>

          <div className="hero-feature hero-feature--top">
            <img src="/assets/creator-1.png" alt="Podcast creator content" />
            <span className="hero-feature__tag">Podcasts</span>
          </div>

          <div className="hero-feature hero-feature--bottom">
            <img src="/assets/AI.jpg" alt="Music creator content" />
            <span className="hero-feature__tag">Music</span>
          </div>

          <div className="floating-stat floating-stat--views">
            <span className="floating-stat__icon">▶</span>
            <div>
              <strong>Grow</strong>
              <small>Build your audience</small>
            </div>
          </div>

          <div className="floating-stat floating-stat--earnings">
            <span className="floating-stat__icon">$</span>
            <div>
              <strong>Earn</strong>
              <small>Choose your model</small>
            </div>
          </div>
        </div>
      </section>

      <section className="network-section" id="creator-paths">
        <div className="network-heading">
          <div>
            <p className="eyebrow">Find your lane</p>
            <h2>Choose your creator path</h2>
          </div>
          <p>
            Rebel is built for the full range of Bahamian storytellers, performers, producers, and personalities.
          </p>
        </div>

        <div className="creator-path-grid">
          <article className="creator-path-card">
            <img src="/assets/Filler3.png" alt="Video creator" />
            <div className="creator-path-card__overlay">
              <span className="path-number">01</span>
              <h3>Video Creators</h3>
              <p>Publish shows, comedy, interviews, sports, commentary, and original videos.</p>
              <a href="#join">Start creating →</a>
            </div>
          </article>

          <article className="creator-path-card">
            <img src="/assets/Filler2.png" alt="Podcaster" />
            <div className="creator-path-card__overlay">
              <span className="path-number">02</span>
              <h3>Podcasters</h3>
              <p>Share interviews, conversations, commentary, and audio-first programmes.</p>
              <a href="#join">Start creating →</a>
            </div>
          </article>

          <article className="creator-path-card">
            <img src="/assets/Filler1.png" alt="Filmmaker and producer" />
            <div className="creator-path-card__overlay">
              <span className="path-number">03</span>
              <h3>Filmmakers &amp; Producers</h3>
              <p>Build an audience for films, series, documentaries, and independent productions.</p>
              <a href="#join">Start creating →</a>
            </div>
          </article>

          <article className="creator-path-card">
            <img src="/assets/Filler4.png" alt="Musician and performer" />
            <div className="creator-path-card__overlay">
              <span className="path-number">04</span>
              <h3>Musicians &amp; Performers</h3>
              <p>Share performances, music videos, behind-the-scenes content, and exclusive releases.</p>
              <a href="#join">Start creating →</a>
            </div>
          </article>
        </div>
      </section>

      <section className="network-section network-section--offer">
        <div className="network-heading network-heading--center">
          <div>
            <p className="eyebrow">More than a place to post</p>
            <h2>What Rebel offers creators</h2>
          </div>
          <p>The tools and flexibility to turn your ideas into a growing creator business.</p>
        </div>

        <div className="offer-grid">
          <article className="offer-card">
            <span className="offer-card__icon">◎</span>
            <h3>Build Your Audience</h3>
            <p>Reach viewers in The Bahamas, the Caribbean, and around the world.</p>
          </article>

          <article className="offer-card">
            <span className="offer-card__icon">▶</span>
            <h3>Earn From Views</h3>
            <p>Free creator accounts may earn advertising revenue from eligible video views.</p>
          </article>

          <article className="offer-card">
            <span className="offer-card__icon">♕</span>
            <h3>Create Premium Content</h3>
            <p>Set a monthly subscription price and offer exclusive content to paying supporters.</p>
          </article>

          <article className="offer-card">
            <span className="offer-card__icon">♡</span>
            <h3>Receive Direct Support</h3>
            <p>Use paid posts, live streams, and FundMe to receive support from your audience.</p>
          </article>

          <article className="offer-card">
            <span className="offer-card__icon">▥</span>
            <h3>Track Your Growth</h3>
            <p>Monitor views, subscribers, earnings, and audience activity from your dashboard.</p>
          </article>

          <article className="offer-card">
            <span className="offer-card__icon">⚡</span>
            <h3>Keep Creative Control</h3>
            <p>Choose your content, your audience strategy, and the monetisation model that works for you.</p>
          </article>
        </div>
      </section>

      {/* <section className="network-section earning-section">
        <div className="earning-section__intro">
          <p className="eyebrow">You choose how you earn</p>
          <h2>
            Two creator models. <span>One platform.</span>
          </h2>
          <p>
            Build a large free audience supported by advertising, or create a premium community that pays monthly for exclusive access.
          </p>
          <Link className="network-button network-button--secondary" to="/creator">
            View Creator FAQ
          </Link>
        </div>

        <div className="earning-models">
          <article className="earning-card earning-card--free">
            <div className="earning-card__top">
              <span className="model-label">Free Account</span>
              <strong>60%</strong>
              <small>Creator share of eligible ad revenue</small>
            </div>
            <ul>
              <li>Grow a larger public audience</li>
              <li>Ads may run before eligible videos</li>
              <li>Offer paid posts and live streams</li>
              <li>Ideal for viral and high-volume content</li>
            </ul>
          </article>

          <article className="earning-card earning-card--premium">
            <div className="popular-label">Premium</div>
            <div className="earning-card__top">
              <span className="model-label">Subscription Account</span>
              <strong>80%</strong>
              <small>Creator share of subscription revenue</small>
            </div>
            <ul>
              <li>Set a monthly price from $5 to $50</li>
              <li>Offer subscriber-only content</li>
              <li>No advertisements on premium content</li>
              <li>Ideal for exclusive fan communities</li>
            </ul>
          </article>
        </div>
      </section> */}
      <section class="network-section earning-section">

        <div class="earning-section__intro">

          <p class="eyebrow">
            You choose how you earn
          </p>

          <h2>
            Two creator models.
            <span>
              One platform.
            </span>
          </h2>

          <p>
            Build a large free audience supported by advertising,
            or create a premium community that pays monthly
            for exclusive access.
          </p>


          <a
            class="network-button network-button--secondary"
            href="creator.php"
          >
            View Creator FAQ
          </a>

        </div>


        <div class="earning-models">

          <article class="earning-card earning-card--free">

            <div class="earning-card__top">

              <span class="model-label">
                Free Account
              </span>

              <strong>
                60%
              </strong>

              <small>
                Creator share of eligible ad revenue
              </small>

            </div>


            <ul>

              <li>
                Grow a larger public audience
              </li>

              <li>
                Ads may run before eligible videos
              </li>

              <li>
                Offer paid posts and live streams
              </li>

              <li>
                Ideal for viral and high-volume content
              </li>

            </ul>

          </article>


          <article class="earning-card earning-card--premium">

            <div class="popular-label">
              Premium
            </div>


            <div class="earning-card__top">

              <span class="model-label">
                Subscription Account
              </span>

              <strong>
                80%
              </strong>

              <small>
                Creator share of subscription revenue
              </small>

            </div>


            <ul>

              <li>
                Set a monthly price from $5 to $50
              </li>

              <li>
                Offer subscriber-only content
              </li>

              <li>
                No advertisements on premium content
              </li>

              <li>
                Ideal for exclusive fan communities
              </li>

            </ul>

          </article>

        </div>

      </section>

      <section className="network-section category-section">
        <div className="network-heading">
          <div>
            <p className="eyebrow">Every kind of creator</p>
            <h2>Culture lives here</h2>
          </div>
          <p>Create in the category you know best—or build something completely new.</p>
        </div>

        <div className="category-cloud">
          <span>Entertainment</span>
          <span>Sports</span>
          <span>Music</span>
          <span>Podcasts</span>
          <span>Documentaries</span>
          <span>Comedy</span>
          <span>News &amp; Commentary</span>
          <span>Culture &amp; Lifestyle</span>
          <span>Food</span>
          <span>Film</span>
        </div>
      </section>

      <section className="network-section join-section" id="join">
        <div className="join-section__copy">
          <p className="eyebrow">Ready to begin?</p>
          <h2>Start your creator journey</h2>
          <p>Set up your account, complete verification, choose your earning model, and start sharing.</p>
          <Link className="network-button network-button--primary" to="/signup">
            Create Your Account
          </Link>
        </div>

        <div className="join-steps">
          <article>
            <span>01</span>
            <div>
              <h3>Create your Rebel account</h3>
              <p>Register and select a Creator Account.</p>
            </div>
          </article>

          <article>
            <span>02</span>
            <div>
              <h3>Complete verification</h3>
              <p>Upload your ID and add your banking details.</p>
            </div>
          </article>

          <article>
            <span>03</span>
            <div>
              <h3>Choose how you earn</h3>
              <p>Select the Free or Premium creator model.</p>
            </div>
          </article>

          <article>
            <span>04</span>
            <div>
              <h3>Start posting</h3>
              <p>Publish your content and begin building your audience.</p>
            </div>
          </article>
        </div>
      </section>

      <section className="creator-final-cta">
        <div>
          <p className="eyebrow">Your opportunity starts here</p>
          <h2>
            Your content. <span>Your audience.</span> Your Rebel.
          </h2>
          <p>You already have the ideas. Rebel gives you a place to share them, grow, and get paid.</p>
        </div>

        <div className="creator-final-cta__actions">
          <Link className="network-button network-button--primary" to="/signup">
            Become a Rebel Creator
          </Link>
          <Link className="network-button network-button--secondary" to="/creator">
            View Creator FAQ
          </Link>
        </div>
      </section>
    </LandingLayout>
  );
};

export default CreatorsNetworkPage;
